import styled from 'styled-components';

import { BREAKPOINTS, colors } from 'common/styles/style-constants';

export const Main = styled.main`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${colors.white};
  margin: 0 -5px;
  height: ${props => props.height};
`;

export const LoadingSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${colors.snow};
  padding: 40px 20px;

  @media (min-width: ${BREAKPOINTS.tabletMin}px) {
    height: 30vh;
  }
`;

export const Title = styled.h1`
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 20px;
`;
